import React, { useState } from 'react';
import { useToast } from '../contexts/ToastContext';
import { useConfirm } from '../contexts/ConfirmContext';

const Alarm = () => {
  const { showToast } = useToast();
  const { showConfirm } = useConfirm();

  const [alarmStats] = useState({
    total: 5,
    critical: 1,
    warning: 2,
    info: 2
  });

  const [alarms] = useState([
    {
      id: 1,
      device: '减速机 #2',
      type: 'critical',
      message: '温度过高，当前温度78°C，超过阈值75°C',
      time: '2024-01-20 14:30:25',
      status: 'active'
    },
    {
      id: 2,
      device: '主电机 #1',
      type: 'warning',
      message: '振动值异常，当前振动4.1mm/s，接近阈值4.5mm/s',
      time: '2024-01-20 13:45:12',
      status: 'active'
    },
    {
      id: 3,
      device: '驱动滚筒 #3',
      type: 'info',
      message: '设备运行时间达到3000小时，建议进行例行检查',
      time: '2024-01-20 12:20:08',
      status: 'acknowledged'
    }
  ]);

  const [alarmHistory] = useState([
    {
      device: '主电机 #1',
      type: 'warning',
      message: '轴承温度略高',
      time: '2024-01-19 16:30',
      status: 'resolved'
    },
    {
      device: '减速机 #2',
      type: 'critical',
      message: '润滑油位低',
      time: '2024-01-18 09:15',
      status: 'resolved'
    },
    {
      device: '驱动滚筒 #3',
      type: 'info',
      message: '设备维护提醒',
      time: '2024-01-17 14:20',
      status: 'resolved'
    }
  ]);

  const [alarmSettings] = useState([
    { name: '温度报警阈值', value: '75°C', icon: 'thermometer-half', color: 'red' },
    { name: '振动报警阈值', value: '4.5mm/s', icon: 'wave-square', color: 'blue' },
    { name: '电流报警阈值', value: '180A', icon: 'bolt', color: 'yellow' },
    { name: '自动确认时间', value: '5分钟', icon: 'clock', color: 'green' }
  ]);

  const handleViewAll = () => {
    showConfirm('查看全部', '确定要查看全部报警历史吗？', () => {
      showToast('正在加载全部报警历史...');
    });
  };

  const handleAcknowledge = (alarmId) => {
    showToast(`已确认报警 #${alarmId}`);
  };

  const handleResolve = (alarmId) => {
    showConfirm('解决报警', '确定要标记此报警为已解决吗？', () => {
      showToast(`报警 #${alarmId} 已标记为已解决`);
    });
  };

  const handleSettingItem = (setting) => {
    showToast(`正在配置${setting.name}...`);
  };

  const getAlarmTypeColor = (type) => {
    switch (type) {
      case 'critical': return 'text-danger-600';
      case 'warning': return 'text-warning-600';
      case 'info': return 'text-primary-600';
      default: return 'text-gray-600';
    }
  };

  const getAlarmTypeBg = (type) => {
    switch (type) {
      case 'critical': return 'bg-danger-50 border-danger-200';
      case 'warning': return 'bg-warning-50 border-warning-200';
      case 'info': return 'bg-primary-50 border-primary-200';
      default: return 'bg-gray-50 border-gray-200';
    }
  };

  const getAlarmTypeIcon = (type) => {
    switch (type) {
      case 'critical': return 'fas fa-exclamation-triangle';
      case 'warning': return 'fas fa-exclamation-circle';
      case 'info': return 'fas fa-info-circle';
      default: return 'fas fa-bell';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'text-danger-600';
      case 'acknowledged': return 'text-warning-600';
      case 'resolved': return 'text-success-600';
      default: return 'text-gray-600';
    }
  };

  return (
    <div className="pb-4">
      {/* 顶部状态栏 */}
      <div className="phm-header">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-xl font-bold">报警管理</h1>
            <p className="text-sm opacity-90">实时报警 · 历史记录</p>
          </div>
          <div className="text-right">
            <div className="text-xs opacity-80">当前报警</div>
            <div className="text-sm font-semibold text-danger-600">{alarmStats.total}个</div>
          </div>
        </div>
      </div>

      {/* 报警统计 */}
      <div className="phm-status-card">
        <h3 className="font-semibold text-gray-800 mb-3">报警统计</h3>
        <div className="phm-metric-grid">
          <div className="phm-metric-item">
            <div className="phm-metric-value text-danger-600">{alarmStats.critical}</div>
            <div className="phm-metric-label">严重报警</div>
          </div>
          <div className="phm-metric-item">
            <div className="phm-metric-value text-warning-600">{alarmStats.warning}</div>
            <div className="phm-metric-label">警告报警</div>
          </div>
          <div className="phm-metric-item">
            <div className="phm-metric-value text-primary-600">{alarmStats.info}</div>
            <div className="phm-metric-label">信息报警</div>
          </div>
          <div className="phm-metric-item">
            <div className="phm-metric-value text-success-600">98.5%</div>
            <div className="phm-metric-label">系统可用性</div>
          </div>
        </div>
      </div>

      {/* 当前报警 */}
      <div className="phm-status-card">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-semibold text-gray-800">当前报警</h3>
          <button 
            className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-lg hover:bg-gray-200 transition-colors"
            onClick={handleViewAll}
          >
            查看全部
          </button>
        </div>
        <div className="space-y-3">
          {alarms.map((alarm) => (
            <div key={alarm.id} className={`p-3 rounded-lg border ${getAlarmTypeBg(alarm.type)}`}>
              <div className="flex items-start justify-between">
                <div className="flex items-start space-x-3 flex-1">
                  <i className={`${getAlarmTypeIcon(alarm.type)} ${getAlarmTypeColor(alarm.type)} mt-1`}></i>
                  <div className="flex-1">
                    <div className="flex items-center space-x-2 mb-1">
                      <span className="font-medium text-gray-800">{alarm.device}</span>
                      <span className={`text-xs px-2 py-1 rounded-full ${
                        alarm.type === 'critical' ? 'bg-danger-100 text-danger-800' :
                        alarm.type === 'warning' ? 'bg-warning-100 text-warning-800' :
                        'bg-primary-100 text-primary-800'
                      }`}>
                        {alarm.type === 'critical' ? '严重' : alarm.type === 'warning' ? '警告' : '信息'}
                      </span>
                    </div>
                    <div className="text-sm text-gray-700 mb-2">{alarm.message}</div>
                    <div className="text-xs text-gray-500">{alarm.time}</div>
                  </div>
                </div>
                <div className="flex flex-col space-y-1 ml-3">
                  <span className={`text-xs ${getStatusColor(alarm.status)}`}>
                    {alarm.status === 'active' ? '活跃' : alarm.status === 'acknowledged' ? '已确认' : '已解决'}
                  </span>
                  {alarm.status === 'active' && (
                    <div className="flex space-x-1">
                      <button 
                        className="px-2 py-1 bg-warning-500 text-white text-xs rounded hover:bg-warning-600 transition-colors"
                        onClick={() => handleAcknowledge(alarm.id)}
                      >
                        确认
                      </button>
                      <button 
                        className="px-2 py-1 bg-success-500 text-white text-xs rounded hover:bg-success-600 transition-colors"
                        onClick={() => handleResolve(alarm.id)}
                      >
                        解决
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 报警历史 */}
      <div className="phm-status-card">
        <h3 className="font-semibold text-gray-800 mb-3">报警历史</h3>
        <div className="space-y-2">
          {alarmHistory.map((alarm, index) => (
            <div key={index} className="flex items-center space-x-3 p-2 bg-gray-50 rounded-lg">
              <i className={`${getAlarmTypeIcon(alarm.type)} ${getAlarmTypeColor(alarm.type)}`}></i>
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-1">
                  <span className="text-sm font-medium text-gray-800">{alarm.device}</span>
                  <span className={`text-xs px-1 py-0.5 rounded ${
                    alarm.type === 'critical' ? 'bg-danger-100 text-danger-800' :
                    alarm.type === 'warning' ? 'bg-warning-100 text-warning-800' :
                    'bg-primary-100 text-primary-800'
                  }`}>
                    {alarm.type === 'critical' ? '严重' : alarm.type === 'warning' ? '警告' : '信息'}
                  </span>
                </div>
                <div className="text-xs text-gray-600">{alarm.message}</div>
                <div className="text-xs text-gray-500">{alarm.time}</div>
              </div>
              <span className={`text-xs ${getStatusColor(alarm.status)}`}>
                {alarm.status === 'resolved' ? '已解决' : '已确认'}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* 报警设置 */}
      <div className="phm-status-card">
        <h3 className="font-semibold text-gray-800 mb-3">报警设置</h3>
        <div className="space-y-3">
          {alarmSettings.map((setting, index) => (
            <div 
              key={index} 
              className="flex items-center justify-between p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
              onClick={() => handleSettingItem(setting)}
            >
              <div className="flex items-center space-x-3">
                <i className={`fas fa-${setting.icon} text-${setting.color}-600`}></i>
                <span className="text-sm text-gray-700">{setting.name}</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-sm text-gray-800">{setting.value}</span>
                <i className="fas fa-chevron-right text-gray-400"></i>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 快速操作 */}
      <div className="phm-status-card">
        <h3 className="font-semibold text-gray-800 mb-3">快速操作</h3>
        <div className="grid grid-cols-2 gap-3">
          <button 
            className="flex items-center justify-center space-x-2 p-3 bg-primary-50 text-primary-700 rounded-lg border border-primary-200 hover:bg-primary-100 transition-colors"
            onClick={() => showToast('正在导出报警报告...')}
          >
            <i className="fas fa-download"></i>
            <span className="text-sm font-medium">导出报告</span>
          </button>
          <button 
            className="flex items-center justify-center space-x-2 p-3 bg-success-50 text-success-700 rounded-lg border border-success-200 hover:bg-success-100 transition-colors"
            onClick={() => showToast('正在发送报警通知...')}
          >
            <i className="fas fa-bell"></i>
            <span className="text-sm font-medium">发送通知</span>
          </button>
          <button 
            className="flex items-center justify-center space-x-2 p-3 bg-warning-50 text-warning-700 rounded-lg border border-warning-200 hover:bg-warning-100 transition-colors"
            onClick={() => showToast('正在测试报警系统...')}
          >
            <i className="fas fa-vial"></i>
            <span className="text-sm font-medium">测试报警</span>
          </button>
          <button 
            className="flex items-center justify-center space-x-2 p-3 bg-purple-50 text-purple-700 rounded-lg border border-purple-200 hover:bg-purple-100 transition-colors"
            onClick={() => showToast('正在配置报警规则...')}
          >
            <i className="fas fa-cog"></i>
            <span className="text-sm font-medium">报警规则</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Alarm;
